// Copyright (c) 2019 Deere & Company

import actions from '../../../sharedmodules/actions-list';

export const updateOktaIsAuthenticated = (isAuthenticated) => ({
    isAuthenticated,
    type: actions.UPDATE_OKTA_STATE_IS_AUTHENTICATED,
});

export const updateOktaUserName = (userName) => ({
    type: actions.UPDATE_OKTA_STATE_USER_NAME,
    userName,
});

export const updateOktaUserId = (userId) => ({
    type: actions.UPDATE_OKTA_STATE_USER_ID,
    userId,
});
